var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bf",class:_vm.classObject,attrs:{"disabled":_vm.disabled}},[_c('i',{staticClass:"fas fa-star",class:{ 'text-accent': !_vm.active }}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }